








































import { Component, Vue } from 'nuxt-property-decorator';
import { mapState } from 'vuex';

import SignUpSocialButtons from '@/components/common/SignUpModal/SignUpSocialButtons/SignUpSocialButtons.vue';
import SignUpForm from '@/components/common/SignUpModal/SignUpForm/SignUpForm.vue';
import { NUMBER_OF_USERS } from '@/components/common/SignUpModal/constants';
import ModalBlack from '@/components/common/SignUpModal/ModalBlack/ModalBlack.vue';
import Modal from '@/components/common/Modal/Modal.vue';

/**
 * Popup component that we show with delay PGE-113
 * Component looks similar to SignUpModal, but has different appearance and doesn't have logic for WebView
 * Also we show regular SignUpModal for mobile devices
 *
 * I didn't merge them into one component intentionally, because it will be really to hard to maintain
 */
@Component<SignUpPopup>({
  name: 'SignUpPopup',
  components: {
    Modal,
    ModalBlack,
    SignUpSocialButtons,
    SignUpForm,
  },
  computed: {
    ...mapState(['promo']),
  },
})
export default class SignUpPopup extends Vue {
  // isUserInsideExternalApp: boolean = false;
  isLoading: boolean = false;
  NUMBER_OF_USERS: string = NUMBER_OF_USERS;
  promo!: string;

  get referer(): string {
    const { query } = this.$route;
    return (query?.refferer || query?.referer) as string;
  }

  get loginParams() {
    return {
      ...(this.promo && { promo: this.promo }),
      auth_source: 'sign-up-popup',
    };
  }

  onSocialLogin(provider: 'google' | 'linkedin') {
    this.$analytics.logEvent(`global__sign-up-popup__${provider}-button__click`);
  }

  navigateToSignIn() {
    this.$analytics.logEvent('global__sign-up-popup__login-link__click');
    this.$modal.showWithRoute('SIGN_IN_MODAL');
  }
}
